"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_popup_common_1 = require("@progress/kendo-popup-common");
var util_1 = require("../util");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * @hidden
 */
var DOMService = /** @class */ (function () {
    function DOMService() {
    }
    DOMService.prototype.addOffset = function (current, addition) {
        return {
            left: current.left + addition.left,
            top: current.top + addition.top
        };
    };
    DOMService.prototype.align = function (settings) {
        return kendo_popup_common_1.align(settings);
    };
    DOMService.prototype.boundingOffset = function (el) {
        return kendo_popup_common_1.boundingOffset(el);
    };
    DOMService.prototype.getWindow = function () {
        return kendo_react_common_1.canUseDOM ? window : null;
    };
    DOMService.prototype.isBodyOffset = function (el) {
        return kendo_popup_common_1.isBodyOffset(el);
    };
    DOMService.prototype.hasOffsetParent = function (el) {
        if (!el) {
            return false;
        }
        var offsetParentEl = el.offsetParent;
        return offsetParentEl &&
            !(offsetParentEl.nodeName === 'BODY' &&
                window.getComputedStyle(offsetParentEl).position === 'static');
    };
    DOMService.prototype.offset = function (el) {
        if (!el) {
            return null;
        }
        return kendo_popup_common_1.offset(el);
    };
    DOMService.prototype.staticOffset = function (element) {
        if (!element) {
            return null;
        }
        var _a = element.style, left = _a.left, top = _a.top;
        element.style.left = '0px';
        element.style.top = '0px';
        var currentOffset = kendo_popup_common_1.offset(element);
        element.style.left = left;
        element.style.top = top;
        return currentOffset;
    };
    DOMService.prototype.position = function (element, popup) {
        if (!element || !popup) {
            return null;
        }
        var parentSibling = kendo_popup_common_1.siblingContainer(element, popup);
        return kendo_popup_common_1.positionWithScroll(element, parentSibling);
    };
    DOMService.prototype.relativeOffset = function (el, currentLocation) {
        return kendo_popup_common_1.applyLocationOffset(this.offset(el), currentLocation, this.isBodyOffset(el));
    };
    DOMService.prototype.addScroll = function (rect, scroll) {
        return kendo_popup_common_1.addScroll(rect, scroll);
    };
    DOMService.prototype.removeScroll = function (rect, scroll) {
        return kendo_popup_common_1.removeScroll(rect, scroll);
    };
    DOMService.prototype.restrictToView = function (settings) {
        return kendo_popup_common_1.restrictToView(settings);
    };
    DOMService.prototype.scrollPosition = function (el) {
        return kendo_popup_common_1.scrollPosition(el);
    };
    DOMService.prototype.scrollableParents = function (el) {
        return util_1.scrollableParents(el);
    };
    DOMService.prototype.stackingElementOffset = function (el) {
        var relativeContextElement = this.getRelativeContextElement(el);
        if (!relativeContextElement) {
            return null;
        }
        return kendo_popup_common_1.offset(relativeContextElement);
    };
    DOMService.prototype.stackingElementScroll = function (el) {
        var relativeContextElement = this.getRelativeContextElement(el);
        if (!relativeContextElement) {
            return { x: 0, y: 0 };
        }
        return {
            x: relativeContextElement.scrollLeft,
            y: relativeContextElement.scrollTop
        };
    };
    DOMService.prototype.stackingElementViewPort = function (el) {
        var relativeContextElement = this.getRelativeContextElement(el);
        if (!relativeContextElement) {
            return null;
        }
        return {
            height: relativeContextElement.scrollHeight,
            width: relativeContextElement.scrollWidth
        };
    };
    DOMService.prototype.getRelativeContextElement = function (el) {
        if (!el || !util_1.HAS_RELATIVE_STACKING_CONTEXT) {
            return null;
        }
        var parent = el.parentElement;
        while (parent) {
            if (window.getComputedStyle(parent).transform !== 'none') {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null;
    };
    DOMService.prototype.useRelativePosition = function (el) {
        return !!this.getRelativeContextElement(el);
    };
    DOMService.prototype.windowViewPort = function (el) {
        return kendo_popup_common_1.getWindowViewPort(el);
    };
    DOMService.prototype.zIndex = function (anchor, container) {
        return util_1.zIndex(anchor, container);
    };
    DOMService.prototype.zoomLevel = function () {
        if (!kendo_react_common_1.canUseDOM) {
            return 1;
        }
        return parseFloat((document.documentElement.clientWidth / window.innerWidth).toFixed(2));
    };
    DOMService.prototype.isZoomed = function () {
        return this.zoomLevel() > 1;
    };
    return DOMService;
}());
exports.DOMService = DOMService;
//# sourceMappingURL=domService.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-popup@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-popup/dist/npm/services/domService.js
// module id = 6621
// module chunks = 0